import React from 'react'
import { Box, Paper, CircularProgress } from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { useQuery, useMutation, queryCache } from 'react-query'
import { useSnackbar } from 'notistack'
import Button from 'UI/Button/ButtonWithPreloader'
import ChangeLogForm, { buildInitValues } from 'components/ChangeLogForm'
import { createChangeLogEntry, getChangeLogRoles } from 'services/changeLog'
import { CHANGE_LOG_MANAGE_URL } from 'constants/routes'
import { SOMETHING_WENT_WRONG } from 'constants/errors'

const ChangeLogCreate = () => {
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()

  const { data: roles, isLoading: isLoadingRoles } = useQuery('changelog-roles', getChangeLogRoles)

  const [createEntryMut, { isLoading }] = useMutation(createChangeLogEntry, {
    onSuccess: () => {
      queryCache.invalidateQueries('changelog-entries')
      queryCache.invalidateQueries('changelog-history')
      enqueueSnackbar('Change log entry successfully published')
      history.push(CHANGE_LOG_MANAGE_URL)
    },
    onError: () => enqueueSnackbar(SOMETHING_WENT_WRONG),
  })

  if (isLoadingRoles) {
    return (
      <Box display="flex" justifyContent="center" p="4rem">
        <CircularProgress color="primary" />
      </Box>
    )
  }

  const availableRoles = roles ? roles.data : []

  return (
    <Box component={Paper} p="3rem" mb="2rem">
      <Box mb="1.5rem">
        <Button variant="text" color="primary" onClick={() => history.push(CHANGE_LOG_MANAGE_URL)}>
          ← Back
        </Button>
      </Box>
      <ChangeLogForm
        heading="Add What's New Entry"
        roles={availableRoles}
        initValues={buildInitValues(availableRoles)}
        loading={isLoading}
        onSubmit={createEntryMut}
        onCancel={() => history.push(CHANGE_LOG_MANAGE_URL)}
      />
    </Box>
  )
}

export default ChangeLogCreate
